export default {
  LIST_FETCHED: 'VIDEO_PLAYLIST_LIST_FETCHED',
  LIST_LOAD: 'VIDEO_PLAYLIST_LIST_LOAD',
  TEMPLATES_FETCHED: 'VIDEO_PLAYLIST_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'VIDEO_PLAYLIST_TEMPLATES_LOAD',
  DETAIL_FETCHED: 'VIDEO_PLAYLIST_DETAIL_FETCHED',
  BUTTON_LOAD: 'VIDEO_PLAYLIST_BUTTON_LOAD',
};
